<template>
  <div class="card bg-gray-100 mb-2 flex items-start relative gap-4 sortable-chosen flex justify-between">
    <div class="flex justify-start gap-2">
      <div class="cursor-pointer" @click="toggleChoice">
        <i v-if="choice.is_correct" class="fas fa-check text-success-500"></i>
        <i v-else class="fas fa-times text-red-500"></i>
      </div>
      <div class="choice__content">
        <div v-if="!isActiveText" class="w-full text-sm " @click="activateText" @input="debounceAnswer">{{ choice.text }}</div>
        <textarea v-else v-model="choice.text" rows="8" class="text-sm relative px-6 py-3 w-full rounded-r focus:shadow-outline"></textarea>
      </div>
    </div>
    <div class="btn-group flex gap-2">
      <button type="button" class="btn-secondary--sm border-r-0" @click="activateText"><i class="fa fa-edit"></i></button>
      <button type="button" class="btn-danger--sm border-r-0" @click="removeChoice"><i class="fa fa-trash"></i></button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuestionChoicesItem',

  props: {
    choice: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
emits: ['was-changed', 'remove'],

  data() {
    return {
      wasChanged: false,
      isActiveText: false,
      debounce: null,
      timeout: 300,
    }
  },

  methods: {
    toggleChoice: function() {
      this.choice.is_correct = !this.choice.is_correct
      this.$emit('was-changed', this.choice )
    },

    activateText: function() {
      this.isActiveText = !this.isActiveText
      this.$emit('was-changed', this.choice )
    },

    debounceAnswer() {
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        this.$emit('was-changed', this.choice )
      }, this.timeout)
    },

    removeChoice() {
      if( confirm('Willst Du diese Auswahl wirklich löschen?') ) {
        this.$emit('remove', this.index)
      }
    },
  },
}
</script>

<style scoped>

</style>